import { constants } from "../../constant";


export const setLoading = (isLoad) => {
    return {type: constants.IS_LOADING, payload: isLoad};
};
